import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import {openPatientForm} from '../../../../store/reducers/patientContext';
import {useDispatch} from 'react-redux';

const useStyles = makeStyles((theme) => ({
    statusBtn: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        minWidth: 182,
        '&.ready': {
            borderColor: '#4EAC6F',
            color: '#4EAC6F',
        },
    },
}));

const OffWardButton = ({patient}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const isFilled = patient?.offWard;
    const isCompleted = isFilled && patient?.offWard?.completed;

    return (
        <AgyleButton
            onClick={() => dispatch(openPatientForm('offWard'))}
            className={clsx(classes.statusBtn, isFilled && 'ready')}
        >
            {!isCompleted && t(isFilled ? 'Off ward' : 'Set off ward')}
            {isCompleted && t('Off ward - Patient Back')}
        </AgyleButton>
    );
};

export default OffWardButton;